export default (px) => px / 16;



// WEBPACK FOOTER //
// ./src/app/utils/px_to_em.js